import { FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { getInputFieldKey } from '../ui/FormBlocker/elements/TextInputElement/TextInputElement'

export function getRequiredInputKeys(elements: FormBlockerElement[]) {
  const textInputElements =
    elements
      ?.map((element, formSectionIndex) => ({ element, formSectionIndex }))
      ?.filter(({ element }) => element.text_input_element) ?? []

  const inputFields = textInputElements.flatMap(({ element, formSectionIndex }) => {
    return (
      element.text_input_element?.input_fields?.map((inputField, inputFieldIndex) => ({
        inputField,
        formSectionIndex,
        inputFieldIndex,
      })) ?? []
    )
  })

  const requiredInputFields = inputFields.filter(({ inputField }) => {
    const validations = inputField.validations?.filter(validation => validation?.regex) ?? []
    return validations?.length > 0
  })

  const requiredInputFieldKeys = requiredInputFields.map(({ formSectionIndex, inputFieldIndex }) => {
    return getInputFieldKey(formSectionIndex, inputFieldIndex)
  })

  return requiredInputFieldKeys
}
